

//set result

export const PUBLISHED_RESULT = 'PUBLISHED_RESULT';

export const LIST_DRAW_RESULT_VN1 = 'LIST_DRAW_RESULT_VN1';
export const FETCH_DRAW_RESULT_VN1 = 'FETCH_DRAW_RESULT_VN1';
export const MODIFY_DRAW_RESULT_VN1 = 'MODIFY_DRAW_RESULT_VN1';
export const CLEAR_DRAW_RESULT_VN1 = 'CLEAR_DRAW_RESULT_VN1';

export const LIST_DRAW_RESULT_TN = 'LIST_DRAW_RESULT_TN';
export const FETCH_DRAW_RESULT_TN = 'FETCH_DRAW_RESULT_TN';
export const MODIFY_DRAW_RESULT_TN = 'MODIFY_DRAW_RESULT_TN';
export const CLEAR_DRAW_RESULT_TN = 'CLEAR_DRAW_RESULT_TN';

export const LIST_DRAW_RESULT_KH = 'LIST_DRAW_RESULT_KH';
export const FETCH_DRAW_RESULT_KH = 'FETCH_DRAW_RESULT_KH';
export const MODIFY_DRAW_RESULT_KH = 'MODIFY_DRAW_RESULT_KH';
export const CLEAR_DRAW_RESULT_KH = 'CLEAR_DRAW_RESULT_KH';







